import { render, staticRenderFns } from "./CUSkeletonLoaderCheckbox.vue?vue&type=template&id=1a9a4a7d"
import script from "./CUSkeletonLoaderCheckbox.vue?vue&type=script&lang=ts"
export * from "./CUSkeletonLoaderCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports